import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EMPTY, expand, map, Observable } from 'rxjs';

import { ENVIRONMENT } from '@ninety/mobile/platform/environments';

import { UserListRequest, UserListRequestFields } from './models/user-list-request.model';
import { UserListResponse } from './models/user-list-response.model';
import { UserListModel } from './models/user-list.model';
import { UserModel } from './user.model';

@Injectable({ providedIn: 'root' })
export class UserListApiService {
  private readonly environment = inject(ENVIRONMENT);
  private readonly http: HttpClient = inject(HttpClient);

  getUserList({ fields, sort }: Pick<UserListRequest, 'fields' | 'sort'>): Observable<UserListModel[]> {
    let [page, fetched] = [0, [] as UserListModel[]];
    const pageSize = 500;
    if (!fields) fields = UserListRequestFields;
    return this.getUserListPage({ fields, page, pageSize, sort }).pipe(
      expand(({ hasMore }) => (hasMore ? this.getUserListPage({ fields, page: ++page, pageSize, sort }) : EMPTY)),
      map(({ users }) => (fetched = [...fetched, ...users]))
    );
  }

  getUserListPage({
    fields,
    page,
    pageSize,
    sort,
  }: Pick<UserListRequest, 'fields' | 'page' | 'pageSize' | 'sort'>): Observable<UserListResponse> {
    if (!fields) fields = UserListRequestFields;
    return this.http.post<UserListResponse>(this.environment.origin.monolith + '/Users/List', {
      fields,
      page,
      pageSize,
      ...(sort ? { sort } : {}),
    });
  }

  updateUser(userId: string | null, update: Partial<UserModel>) {
    if (!userId) return EMPTY;
    return this.http.patch<UserModel>(this.environment.origin.monolith + '/Users/' + userId, update);
  }
}
